// extracted by mini-css-extract-plugin
export default {"wrapper":"ifovMViQgxSntFbKr71l","list":"R4T92UoU4mAT20dfmkF8","listItem":"ufbJfccgBiNpKcIxbSfL"};